var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "StepLayout",
    { attrs: { "class-name": "m-step" } },
    [
      _vm.isBailianFlag
        ? _c("p", { staticClass: "required-remark" }, [
            _c("span", { staticClass: "require-icon" }, [_vm._v("*")]),
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.mode === "edit"
                    ? _vm.$t("storeVisitReport.SSTable.msg1")
                    : ""
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "main-table-container",
          attrs: { model: _vm.form, rules: _vm.rules, size: "small" },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "m-table",
              class: { "error-table": _vm.hasErrorTable },
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.form.storeInfo.tireSalesInfos,
                border: "",
                stripe: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.tableIndex,
                  label: _vm.$t(
                    "retailStoresInfo.form.otherBrandSales.systemPk"
                  ),
                  width: "120",
                  align: "left",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tireBrand",
                  label: _vm.$t("storeVisitReport.SSTable.tireBrand"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.$index < 7 ? "required" : "" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.tireBrand) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tireSupplier",
                  label: _vm.$t("storeVisitReport.SSTable.mainChannel"),
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "u-formItem",
                            attrs: {
                              rules: scope.$index < 7 ? _vm.rules.iptEmpty : [],
                              prop:
                                "storeInfo.tireSalesInfos." +
                                scope.$index +
                                ".tireSupplier",
                            },
                          },
                          [
                            _c("FormSelect", {
                              attrs: {
                                val: scope.row.tireSupplier,
                                options: _vm.optConfig.tireSupplierOptions,
                                mode: _vm.mode,
                              },
                              on: {
                                "update:val": function (v) {
                                  return _vm.updateFormValue(
                                    v,
                                    "tireSupplier",
                                    scope.row
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "paymentTerms",
                  label: _vm.$t("storeVisitReport.SSTable.payway"),
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "u-formItem",
                            attrs: {
                              rules: scope.$index < 7 ? _vm.rules.iptEmpty : [],
                              prop:
                                "storeInfo.tireSalesInfos." +
                                scope.$index +
                                ".paymentTerms",
                            },
                          },
                          [
                            _c("FormSelect", {
                              attrs: {
                                val: scope.row.paymentTerms,
                                options: _vm.optConfig.accountMethodOptions,
                                mode: _vm.mode,
                              },
                              on: {
                                "update:val": function (v) {
                                  return _vm.updateFormValue(
                                    v,
                                    "paymentTerms",
                                    scope.row
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "monthlyAvgSales",
                  label: _vm.$t("storeVisitReport.SSTable.AMSales"),
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "u-formItem",
                            attrs: {
                              rules: scope.$index < 7 ? _vm.rules.iptEmpty : [],
                              prop:
                                "storeInfo.tireSalesInfos." +
                                scope.$index +
                                ".monthlyAvgSales",
                            },
                          },
                          [
                            _c("FormInputNumber", {
                              attrs: {
                                val: scope.row.monthlyAvgSales,
                                step: 1,
                                mode: _vm.mode,
                              },
                              on: {
                                "update:val": function (v) {
                                  return _vm.updateFormValue(
                                    v,
                                    "monthlyAvgSales",
                                    scope.row
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "stock",
                  label: _vm.$t("storeVisitReport.SSTable.stock"),
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "u-formItem",
                            attrs: {
                              rules: scope.$index < 7 ? _vm.rules.iptEmpty : [],
                              prop:
                                "storeInfo.tireSalesInfos." +
                                scope.$index +
                                ".stock",
                            },
                          },
                          [
                            _c("FormInputNumber", {
                              attrs: {
                                val: scope.row.stock,
                                step: 1,
                                mode: _vm.mode,
                              },
                              on: {
                                "update:val": function (v) {
                                  return _vm.updateFormValue(
                                    v,
                                    "stock",
                                    scope.row
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tyreEighteenGreater" }, [
            _c(
              "div",
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "u-iptItem f-ib",
                    attrs: {
                      prop: "storeInfo.tyreEighteenGreater",
                      rules: _vm.rules.tyreEighteenGreaterEmpty,
                    },
                  },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "retailStoresInfo.form.otherBrandSales.tyreEighteenGreater"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "FormInputNumber",
                      {
                        staticClass: "tyreEighteenGreater-input",
                        attrs: {
                          val: _vm.form.storeInfo.tyreEighteenGreater,
                          max: 100,
                          step: 0.01,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "tyreEighteenGreater",
                              $event
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "append" }, slot: "append" },
                          [_vm._v("%")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rightNavGroup",
          attrs: { slot: "rightBox" },
          slot: "rightBox",
        },
        [
          _c("div", { staticClass: "statisticBox" }, [
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.$t("storeVisitReport.SStatistic.AvMSalesOfTires"))
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.monthlyStatistic)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.$t("storeVisitReport.SStatistic.stockTotal"))
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.stockStatistic)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.$t("storeVisitReport.SStatistic.updateTime"))
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.info.storeInfo.tireSalesLastUpdateTime)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-actions" },
            [
              _vm.mode === "edit"
                ? [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.onSaveDraft },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.onDraftAndGo },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.nextStep")))]
                    ),
                  ]
                : [
                    _c(
                      "el-button",
                      {
                        key: _vm.mode,
                        attrs: {
                          type: "primary",
                          size: "small",
                          disabled: _vm.mode === "error",
                        },
                        on: { click: _vm.onNext },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.nextStep")))]
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }